import { render } from "./One1.vue?vue&type=template&id=8612aca6&scoped=true&lang=pug"
import script from "./One1.vue?vue&type=script&lang=js"
export * from "./One1.vue?vue&type=script&lang=js"

import "./One1.vue?vue&type=style&index=0&id=8612aca6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8612aca6"]])

export default __exports__